import React, { CSSProperties, ReactNode, forwardRef } from 'react'
import styles from './styles/main-container.module.scss'
import classNames from 'classnames'

interface Props {
  children: ReactNode
  className?: string
  hasBorder?: boolean
  style?: CSSProperties
}

/**
 *
 * Main container that defines max layout width
 *
 */

const MainContainer = forwardRef<HTMLDivElement, Props>(
  ({ children, className, style, hasBorder = false }, ref) => (
    <div
      ref={ref}
      className={classNames(styles.mainContainer, className, { [styles.border]: hasBorder })}
      style={style}
    >
      {children}
    </div>
  )
)

export default MainContainer
